import api from "../../../api/axios";

// Feature-local wrapper for GET /api/companies/?search=<q>&page=1.
// Duplicates features/companyFinder/api/companies.js intentionally —
// consumer #2 of the pattern. A shared/api/companies.js extraction is
// deferred until a third consumer arrives (two-is-the-bar rule, see
// migration/phase11-multi-field-plan.md §6.2).
//
// DRF SearchFilter performs case-insensitive icontains on
// CompanyViewSet.search_fields = ("name", "description", "city").
// Returns the raw paginated envelope { count, next, previous, results }.
export const searchCompanies = (query, { signal } = {}) =>
  api
    .get("/companies/", {
      params: { search: query, page: 1 },
      signal,
    })
    .then((res) => res.data);
